<template>
  <div>
      <v-container fluid>
          <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
              <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
              <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>

          <v-card class="box" flat v-if="add_new == true">
             <v-toolbar class="toolbar" flat dense>
               <v-toolbar-title>
                      <strong> Add New Lesson Plans</strong>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                    <v-btn class="button" :loading="loader" @click="addChapter()"><v-icon>mdi-plus</v-icon>Add Chapter</v-btn>
                     <v-spacer></v-spacer>
              <v-btn fab small color="white" outlined icon @click="add_new = false"><v-icon> mdi-close </v-icon></v-btn>
             </v-toolbar>
             <br/>
                <v-row dense justify="center">
                    <v-col class="v-col" sm="5">
                        <v-file-input placeholder="Add File" prepend-icon="mdi-paperclip" label="File Data" show-size flat rounded outlined dense v-model="file"></v-file-input>
                    </v-col>
                     <v-col class="v-col" sm="1"></v-col>
                      <v-col class="v-col" sm="5">
                        <v-autocomplete dense rounded v-model="course_plan_week" item-value="id" :items="course_plan_week_list" item-text="name" label="Course Plan Week" outlined></v-autocomplete>
                      </v-col>
                </v-row>
              <v-row dense justify="center">
                    <v-col class="v-col" sm="5">
                        <v-autocomplete dense rounded v-model="chapter" item-value="id" :items="chapters_list" item-text="name" label="Chapter" outlined></v-autocomplete>
                      </v-col>
                   <v-col class="v-col" sm="1"></v-col>
                  <v-col class="v-col" sm="5">
                     <v-textarea v-model="topic" color="#0F2027" rounded dense label="Concept Skill / Topic" placeholder="Concept Skill / Topic" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                    <v-textarea v-model="outcome" color="#0F2027" rounded dense label="Learning Outcomes" placeholder="Learning Outcomes" outlined></v-textarea>
                  </v-col>
                    <v-col class="v-col" sm="1"></v-col>
                   <v-col class="v-col" sm="5">
                     <v-textarea v-model="tools" color="#0F2027" rounded dense label="Instructional Tools & References" placeholder="Instructional Tools & References" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                     <v-textarea v-model="pedagogy" color="#0F2027" rounded dense label="Pedagogy" placeholder="Pedagogy" outlined></v-textarea>
                  </v-col>
                   <v-col class="v-col" sm="1"></v-col>
                  <v-col class="v-col" sm="5">
                     <v-textarea v-model="assignment" color="#0F2027" rounded dense label="Activity / Assignment / Research" placeholder="Activity / Assignment / Research" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                    <v-textarea v-model="assessment" color="#0F2027" rounded dense label="Assessment" placeholder="Assessment" outlined></v-textarea>
                  </v-col>
                  <v-col class="v-col" sm="1"></v-col>
                   <v-col class="v-col" sm="5">
                     <v-textarea v-model="exammination" color="#0F2027" rounded dense label="Examination" placeholder="Examination" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="2">
                      <v-btn class="button" :loading="loader" @click="saveLessonPlan"><v-icon>mdi-plus</v-icon>Add</v-btn>
                  </v-col>
              </v-row>
          </v-card>

          <v-card class="box" >
              <v-toolbar flat dense>
                  <v-col cols="12" sm="1" md="1">
                      <v-btn v-if="plan_list != ''" rounded color="success" outlined @click="fnExcelReport('my-table-id', 'LessonPlanningReport')" :loading="loader">
                            <v-icon  color="success">mdi-export</v-icon>Export
                    </v-btn>
                  </v-col>
                   <v-col cols="12" sm="3" md="3">
                     <v-btn class="button" v-if="role == '1' && plan_list != ''" :loading="loader"  @click="rearrangelessonplans()">Rearrange Lesson Numbers</v-btn>
                   </v-col>
                  <v-text-field class="pt-2" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                  <v-btn class="button" v-if="role == '2'" @click="addnew">Add New Lesson Plan</v-btn>
              </v-toolbar>
              <span v-if="role == '1'">
                <div id="my-table-id">
                    <v-data-table v-model="selectedTasks" :single-select="singleSelect" dense :headers="headers" item-key="cp_id" show-select :search="search" :items="plan_list" class="elevation-1 mytable">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-row>
                                <span v-if="role == '2'">
                                    <v-btn x-small fab icon outlined color="#0F2027">
                                        <v-icon x-small color="#0F2027" @click="editItem(item.cp_id)" title="edit">edit</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab outlined icon color="error" class="btn">
                                        <v-icon x-small color="error" @click="deletedItem(item.cp_id)" title="edit">delete</v-icon>
                                    </v-btn>
                                </span>
                                <span>
                                    <v-btn icon> <v-icon color="primary" @click="showDetails(item)">mdi-eye</v-icon></v-btn>
                                </span>
                                <span v-if="item.file != null">
                                    <a class="p-2" :href="aws_path+item.file" target="blank">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                            </template>
                                            <span>
                                                View Lesson Document File!!!
                                            </span>
                                        </v-tooltip>
                                    </a>
                                </span>
                            </v-row>
                        </template>
                        <template v-slot:[`item.isapproved`]="{ item }">
                        <span v-if="item.isapproved">
                            <v-icon class="mr-2 v-icon-size" color="success"
                            >mdi-check-circle-outline</v-icon
                            >
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error"
                            >mdi-close-circle-outline</v-icon
                            >
                        </span>
                        </template>
                        <template v-slot:[`item.chapter`]="{ item }">
                            {{ item.unit || item.chapter || '-' }}
                        </template>
                    </v-data-table>
                </div>
              </span>
              <span v-else>
                    <v-data-table dense :headers="headers"  :search="search" :items="plan_list" class="elevation-1 mytable">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-row>
                                <span v-if="role == '2'">
                                    <v-btn x-small fab icon outlined color="#0F2027">
                                        <v-icon x-small color="#0F2027" @click="editItem(item.cp_id)" title="edit">edit</v-icon>
                                    </v-btn>
                                    <v-btn x-small fab outlined icon color="error" class="btn">
                                        <v-icon x-small color="error" @click="deletedItem(item.cp_id)" title="edit">delete</v-icon>
                                    </v-btn>
                                </span>
                                <span>
                                    <v-btn icon> <v-icon color="primary" @click="showDetails(item)">mdi-eye</v-icon></v-btn>
                                </span>
                                <span v-if="item.file != null">
                                    <a class="p-2" :href="aws_path+item.file" target="blank">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                            </template>
                                            <span>
                                                View Lesson Document File!!!
                                            </span>
                                        </v-tooltip>
                                    </a>
                                </span>
                            </v-row>
                        </template>
                        <template v-slot:[`item.isapproved`]="{ item }">
                        <span v-if="item.isapproved">
                            <v-icon class="mr-2 v-icon-size" color="success"
                            >mdi-check-circle-outline</v-icon
                            >
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error"
                            >mdi-close-circle-outline</v-icon
                            >
                        </span>
                        </template>
                        <template v-slot:[`item.chapter`]="{ item }">
                            {{ item.unit || item.chapter || '-' }}
                        </template>
                    </v-data-table>
              </span>

                <center v-if="selectedTasks!=''">
                    <v-btn class="button" color="orange" v-if="role == '1' && plan_list != ''" :loading="loader"  @click="approveLessonPlans(true)">Approve Lesson Plans</v-btn>
                    <v-btn class="button" color="red" v-if="role == '1' && plan_list != ''" :loading="loader"  @click="approveLessonPlans(false)">Unapprove Lesson Plans</v-btn>
                </center>
          </v-card>


          <!-- Edit Lesson Plan Start-->
          <!-- Edit unit-->

          <v-card flat class="box" v-if="edit_new == true">
             <v-toolbar class="toolbar" flat dense>
               <v-toolbar-title>
                      <strong> Edit Lesson Plans</strong>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
              <v-btn fab small color="white" outlined icon @click="edit_new = false"><v-icon> mdi-close </v-icon></v-btn>
             </v-toolbar>
             <br/>
             <!-- {{edit_plan_details_list}} -->
              <!-- <v-col cols="12" lg="9" sm="12"> -->
                <v-row dense justify="center">
                    <v-col class="v-col" sm="5">
                    <v-text-field v-model="edit_plan_details_list[0].lesson_no" color="#0F2027" rounded dense label="Lecture No" placeholder="Lecture No" outlined></v-text-field>
                    </v-col>
                      <v-col class="p-none" cols="2" lg="2" sm="2">
               <v-btn small color="primary" @click="updateLessonNo(edit_plan_details_list[0].id,edit_plan_details_list[0].lesson_no)" title="Update">Update Lecture No</v-btn>
             </v-col>
                </v-row>
                <v-row dense justify="center">
                    <v-col class="v-col" sm="5">
                        <v-file-input placeholder="Add File" label="File Data" show-size flat rounded outlined dense v-model="edit_file"></v-file-input>
                        <span v-if="edit_plan_details_list[0].attachment != null && edit_plan_details_list[0].attachment != ''">
                                <a class="p-2" :href="aws_path+edit_plan_details_list[0].attachment" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="mb-5" icon v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span>
                                            View Lesson Document File!!!
                                        </span>
                                    </v-tooltip>
                                </a>
                            </span>
                            <v-btn
                                v-if="edit_plan_details_list[0].attachment != null && edit_plan_details_list[0].attachment != ''"
                                x-small
                                fab
                                outlined
                                icon
                                color="error"
                                @click="deletePlanFile(edit_plan_details_list[0].id)"
                                class="btn1 mb-5 mr-2"
                            >
                                <v-icon x-small color="error" title="Delete Lesson Plan File">delete</v-icon>
                            </v-btn>
                    </v-col>
                     <v-col class="v-col" sm="1"></v-col>
                      <v-col class="v-col" sm="5">
                        <v-autocomplete dense rounded v-model="edit_plan_details_list[0].courseplanweek_id" item-value="id" :items="course_plan_week_list" item-text="name" label="Course Plan Week" outlined></v-autocomplete>
                      </v-col>
                </v-row>
               <v-row dense justify="center">
                    <v-col class="v-col" sm="5">
                        <!-- <v-autocomplete dense rounded v-model="edit_plan_details_list[0].chapter_id" item-value="id" :items="chapters_list" item-text="name" label="Chapter" outlined></v-autocomplete> -->
                        <v-autocomplete dense rounded v-model="edit_plan_details_list[0].chapter_id" item-value="id"
                            :items="chapters_list" item-text="name" label="Chapter" outlined
                            :return-object="false"></v-autocomplete>
                    </v-col>
                   <v-col class="v-col" sm="1"></v-col>
                  <v-col class="v-col" sm="5">
                     <v-textarea v-model="edit_plan_details_list[0].topic" color="#0F2027" rounded dense label="Concept Skill / Topic" placeholder="Concept Skill / Topic" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                    <v-textarea v-model="edit_plan_details_list[0].learning_outcomes" color="#0F2027" rounded dense label="Learning Outcomes" placeholder="Learning Outcomes" outlined></v-textarea>
                  </v-col>
                    <v-col class="v-col" sm="1"></v-col>
                   <v-col class="v-col" sm="5">
                     <v-textarea v-model="edit_plan_details_list[0].instructional_tool_refernences" color="#0F2027" rounded dense label="Instructional Tools & References" placeholder="Instructional Tools & References" outlined></v-textarea>
                  </v-col>
              </v-row>
               <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                     <v-textarea v-model="edit_plan_details_list[0].pedagogy" color="#0F2027" rounded dense label="Pedagogy" placeholder="Pedagogy" outlined></v-textarea>
                  </v-col>
                   <v-col class="v-col" sm="1"></v-col>
                  <v-col class="v-col" sm="5">
                     <v-textarea v-model="edit_plan_details_list[0].activity_assignment_research" color="#0F2027" rounded dense label="Activity / Assignment / Research" placeholder="Activity / Assignment / Research" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="5">
                    <v-textarea v-model="edit_plan_details_list[0].assessment" color="#0F2027" rounded dense label="Assessment" placeholder="Assessment" outlined></v-textarea>
                  </v-col>
                  <v-col class="v-col" sm="1"></v-col>
                   <v-col class="v-col" sm="5">
                     <v-textarea v-model="edit_plan_details_list[0].exam_name" color="#0F2027" rounded dense label="Examination" placeholder="Examination" outlined></v-textarea>
                  </v-col>
              </v-row>
              <v-row dense justify="center">
                  <v-col class="v-col" sm="2">
                      <v-btn class="button" :loading="loader" @click="upatelessonplans"><v-icon>mdi-plus</v-icon>Update</v-btn>
                  </v-col>
              </v-row>
           
          </v-card>

          <!-- Edit Lesson Plan end-->

          <v-dialog v-model="dialog_delete" persistent max-width="600px">
              <v-card>
                  <v-container>
                      <v-card class="box">
                          <v-row dense justify="center">
                              <strong>Are you sure you want Delete ???</strong>
                          </v-row>
                          <v-row dense justify="center">
                              <v-btn class="button" outlined @click="dialog_delete = false">No</v-btn>
                              <v-btn
                                  class="button"
                                  outlined
                                  @click="
                deletelistvalue_yes(
                  delete_index,
                  delete_type,
                  edit_course_plan_id
                )
              "
                              >
                                  Yes
                              </v-btn>
                          </v-row>
                      </v-card>
                  </v-container>
              </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_delete1" persistent max-width="600px">
              <v-card>
                  <v-container>
                      <v-card class="box">
                          <v-row dense justify="center">
                              <strong>Are you sure you want Delete ???</strong>
                          </v-row>
                          <v-row dense justify="center">
                              <v-btn class="button" outlined @click="dialog_delete1 = false">No</v-btn>
                              <v-btn class="button" outlined @click="deleteplan(edit_course_plan_id)">Yes</v-btn>
                          </v-row>
                      </v-card>
                  </v-container>
              </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_add_new" persistent max-width="900px">
              <v-card>
                  <v-container>
                      <v-card class="box">
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'unit'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field v-model="addnewlessonplan.unit" color="#0F2027" rounded dense label="Add New Chapter" placeholder="Add New Chapter" outlined></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'topic'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field v-model="addnewlessonplan.topic" color="#0F2027" rounded dense label=" Add New Concept Skill / Topic" placeholder="Add New Concept Skill / Topic" outlined></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'outcome'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field v-model="addnewlessonplan.outcome" color="#0F2027" rounded dense label="Add New Learning Outcomes" placeholder="Add New Learning Outcomes" outlined></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'tool'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field
                                      v-model="addnewlessonplan.tools"
                                      color="#0F2027"
                                      rounded
                                      dense
                                      label="Add New Instructional Tools & References"
                                      placeholder="Add New Instructional Tools & References"
                                      outlined
                                  ></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'pedagogy'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field v-model="addnewlessonplan.pedagogy" color="#0F2027" rounded dense label="Add New Pedagogy" placeholder="Add New Pedagogy" outlined></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'assignment'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field
                                      v-model="addnewlessonplan.assignment"
                                      color="#0F2027"
                                      rounded
                                      dense
                                      label="Add New Activity / Assignment / Research"
                                      placeholder="Add New Activity / Assignment / Research"
                                      outlined
                                  ></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'assessment'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field v-model="addnewlessonplan.assessment" color="#0F2027" rounded dense label="Add New Assessment" placeholder="Add New Assessment" outlined></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center" v-if="addnewlessonplan.type == 'examination'">
                              <v-col class="v-col" sm="6">
                                  <v-text-field v-model="addnewlessonplan.exammination" color="#0F2027" rounded dense label="Add New Examination" placeholder="Add New Examination" outlined></v-text-field>
                              </v-col>
                          </v-row>
                          <v-row dense justify="center">
                              <v-btn class="button" outlined @click="dialog_add_new = false">Cancel</v-btn>
                              <v-btn
                                  class="button"
                                  outlined
                                  @click="
                addnewLessonPlanData(
                  edit_course_plan_id,
                  addnewlessonplan.type
                )
              "
                              >
                                  Save
                              </v-btn>
                          </v-row>
                      </v-card>
                  </v-container>
              </v-card>
          </v-dialog>

           <v-dialog v-model="dialog_add_comment" persistent max-width="1200px">
              <v-card>
                  <v-container>
                      <v-card class="box">
                        <v-toolbar class="toolbar" flat dense>
                            <v-toolbar-title>Add Plan Comment</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <br>
                          <v-row dense justify="center">
                            <v-col class="v-col" sm="5">
                                 <v-text-field
                                            dense
                                            rounded
                                            outlined
                                            v-model="showlessonplan.lesson_no"
                                            label="Lecture No"
                                            readonly
                                        ></v-text-field>
                                 <!-- <v-textarea o/utlined name="input-5-3" v-model="showlessonplan.unit" readonly label="Unit"></v-textarea>   -->
                            </v-col>
                             <v-col class="v-col" sm="1">
                            </v-col>
                            <v-col class="v-col" sm="5">
                                <v-text-field dense rounded outlined v-model="showlessonplan.courseplanweek" readonly label="Course Plan Week"></v-text-field>  
                            </v-col>
                          </v-row>
                         <v-row dense justify="center">
                            <v-col class="v-col" sm="5">
                                 <v-text-field
                                            dense
                                            rounded
                                            outlined
                                            v-model="showlessonplan.unit"
                                            label="Unit"
                                        ></v-text-field>
                                 <!-- <v-textarea o/utlined name="input-5-3" v-model="showlessonplan.unit" readonly label="Unit"></v-textarea>   -->
                            </v-col>
                            <v-col class="v-col" sm="1">
                            </v-col>
                             <v-col class="v-col" sm="5">
                                     <v-text-field
                                            dense
                                            rounded
                                            outlined v-model="showlessonplan.topic" readonly label="Topic"></v-text-field>  
                            </v-col>
                         </v-row>
                          <v-row dense justify="center">
                            <v-col class="v-col" sm="5">
                                      <v-text-field
                                            dense
                                            rounded
                                            outlined v-model="showlessonplan.outcome" readonly label="Outcome"></v-text-field>  
                            </v-col>
                            <v-col class="v-col" sm="1">
                            </v-col>
                             <v-col class="v-col" sm="5">
                                      <v-text-field
                                            dense
                                            rounded
                                            outlined name="input-5-3" v-model="showlessonplan.tools" readonly label="Tools"></v-text-field>  
                            </v-col>
                         </v-row>
                          <v-row dense justify="center">
                            <v-col class="v-col" sm="5">
                                      <v-text-field
                                            dense
                                            rounded
                                            outlined v-model="showlessonplan.pedagogy" readonly label="Outcome"></v-text-field>  
                            </v-col>
                            <v-col class="v-col" sm="1">
                            </v-col>
                             <v-col class="v-col" sm="5">
                                      <v-text-field
                                            dense
                                            rounded
                                            outlined v-model="showlessonplan.assignment" readonly label="Tools"></v-text-field>  
                            </v-col>
                         </v-row>
                          <v-row dense justify="center">
                            <v-col class="v-col" sm="5">
                                      <v-text-field
                                            dense
                                            rounded
                                            outlined v-model="showlessonplan.assessment" readonly label="Outcome"></v-text-field>  
                            </v-col>
                            <v-col class="v-col" sm="1">
                            </v-col>
                             <v-col class="v-col" sm="5">
                                     <v-text-field
                                            dense
                                            rounded
                                            outlined v-model="showlessonplan.exammination" readonly label="Tools"></v-text-field>  
                            </v-col>
                         </v-row>
                        <v-row dense justify="center">
                              <v-col class="v-col" sm="5">
                                    <v-textarea
                                    outlined
                                    name="input-7-4"
                                    v-model="showlessonplan.remark"
                                    label="Add Plan Remark"
                                ></v-textarea>                            
                              </v-col>
                          </v-row>
                        <v-row dense justify="center">
                         <v-btn v-if="showlessonplan.remark && role == '1'" class="button" outlined @click="addRemark()">Save</v-btn>
                        <v-btn class="button" outlined @click="dialog_add_comment= false">Close</v-btn>
                        </v-row>
                      </v-card>
                  </v-container>
              </v-card>
          </v-dialog>

           <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <!-- <v-btn class="button" v-on="on">Add Chapter</v-btn> -->
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">Chapter</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="chapter_name"
                          color="#0F2027"
                          dense
                          rounded
                          outlined
                          persistent-hint
                          hint="Chapter Name"
                          label="Chapter Name"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          dense
                          v-model="isactive"
                          color="success"
                          label="Active"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text> 

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="dialog=false">Cancel</v-btn>
                  <v-btn class="button" @click="saveChapter()" :disabled="!chapter_name">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
      </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
      props: {
          plan_list: Array,
          role: String,
          course: String,
          lesson_no:String,
          islessonplanapproved:Boolean,
          ay:Number,
          course_plan_week_list:Array,
          chapters_list:Array
      },
      data() {
          return {
              chapter_name:"",
              dialog:false,
              singleSelect: false,
              selectedTasks: [],
              course_plan_week:null,
              dialog_add_comment:false,
              loader:false,
              snackbar_msg: "",
              color: "",
              snackbar: false,
              search: null,
              ay_std_div_list: null,
              sel_ay_data: null,
              show_tt: false,
              std_div_list: null,
              sel_std_data: null,
              div_list: null,
              div: null,
              overlay: false,
              crs_list: null,
              crs: null,
              lesson_no_edit: "",
             // lesson_no: 1,
              chapter: null,
              unit: null,
              topic: null,
              outcome: null,
              tools: null,
              pedagogy: null,
              assignment: null,
              assessment: null,
              exammination: null,
              plan: false,
              add_new: false,
              edit_new: false,
              // plan_list: [],
              dialog_delete: false,
              file: null,
              headers: [
                //   { text: "Sr. No.", value: "sr_no" },
                  { text: "Academic Year", value: "academicyear" },
                  { text: "Lecture No", value: "lecture_no" },
                  { text: "Chapter", value: "chapter" },
                  { text: "Remark", value: "remark" },
                  { text: "Is Approved?", value: "isapproved" },
                  { text: "Approval Date", value: "approval_date" },
                  { text: "Approved By", value: "approvedby" },
                //   { text: "Concept & Skills / Topic", value: "topic" },
                //   { text: "Learning Outcomes", value: "learning_outcomes" },
                //   {
                //       text: "Instructional Tools & Reference",
                //       value: "instructional_tool_refernences",
                //   },
                //   { text: "Pedagogy", value: "pedagogy" },
                //   {
                //       text: " Activity / Assignment / Research",
                //       value: "activity_assignment_research",
                //   },
                //   { text: "Assessment", value: "assessment" },
                //   { text: "Examination", value: "exam_name" },
                  { text: "Actions", value: "action", sortable: false },
              ],
              table_fields: {
                  "Sr. No": "sr_no",
                  "Lecture No": "lecture_no",
                  Chapter: "unit",
                  "Concept & Skills / Topic": "topic",
                  "Learning Outcomes": "learning_outcomes",
                  "Instructional Tools & Reference": "instructional_tool_refernences",
                  Pedagogy: "pedagogy",
                  "Activity / Assignment / Research": "activity_assignment_research",
                  Assessment: "assessment",
                  Examination: "exam_name",
              },
              unit_list: null,
              edit_course_plan_week:null,
              edit_chapter:null,
              edit_unit: null,
              topic_list: null,
              edit_topic: null,
              outcome_list: null,
              edit_outcome: null,
              tool_list: null,
              edit_tool: null,
              pedagogy_list: null,
              edit_pedagogy: null,
              assignment_list: null,
              edit_assignment: null,
              assessment_list: null,
              assessment_edit: null,
              examination_list: null,
              exammination_edit: null,
              edit_course_plan_id: null,
              unit_index: null,
              topic_index: null,
              tool_index: null,
              outcome_index: null,
              pedagogy_index: null,
              assignment_index: null,
              aassessment_index: null,
              exammination_index: null,
              delete_index: null,
              delete_type: null,
              dialog_delete1: false,
              unit_flag: false,
              topic_flag: false,
              tool_flag: false,
              outcome_flag: false,
              pedagogy_flag: false,
              assignment_flag: false,
              aassessment_flag: false,
              exammination_flag: false,
              dialog_add_new: false,
              add_new_list: [],
              filepath: null,
              filename: null,
              aws_path: null,
              edit_file: null,
              addnewlessonplan: {
                  type: null,
                  unit: null,
                  topic: null,
                  outcome: null,
                  tools: null,
                  pedagogy: null,
                  assignment: null,
                  assessment: null,
                  exammination: null,
              },
              showlessonplan: {
                  id:null,
                  lesson_no:null,
                  type: null,
                  unit: null,
                  topic: null,
                  outcome: null,
                  tools: null,
                  pedagogy: null,
                  assignment: null,
                  assessment: null,
                  exammination: null,
                  remark:null,
                  courseplanweek:null
              },
              edit_plan_details_list:{
              },
              edit_file:null,edit_course_plan_id:null
          };
      },
      methods: {

         async upatelessonplans() {
                let formData = new FormData();
                formData.append("edit_file", this.edit_file);
                formData.append("edit_course_plan_id", this.edit_plan_details_list[0].id);
                formData.append("topic", this.edit_plan_details_list[0].topic);
                formData.append("learning_outcomes", this.edit_plan_details_list[0].learning_outcomes);
                formData.append("instructional_tool_refernences", this.edit_plan_details_list[0].instructional_tool_refernences);
                formData.append("pedagogy", this.edit_plan_details_list[0].pedagogy);
                formData.append("activity_assignment_research", this.edit_plan_details_list[0].activity_assignment_research);
                formData.append("assessment", this.edit_plan_details_list[0].assessment);
                formData.append("exam_name", this.edit_plan_details_list[0].exam_name);
                formData.append("remark", this.edit_plan_details_list[0].remark);
                formData.append("chapter_id", this.edit_plan_details_list[0].chapter_id);
                formData.append("courseplanweek_id", this.edit_plan_details_list[0].courseplanweek_id);
                formData.append("unit", this.edit_plan_details_list[0].unit);
                 this.loader=true
              axios
                 try {
          const res = await axios.post("/LessonPlanning/save_edit_plan_WWS", formData);
          if (res.data.flag == "YES") {
                this.loader=false
                this.showSnackbar("green", "Lesson Plans Updated Successfully.."); // show snackbar
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                 this.loader=false,
                 this.edit_file=null,
                 this.edit_plan_details_list={}
                 this.getLessonPlan();
      }
          },
        saveChapter(){
        const formData = {
          crs_id: this.course,
          chapter_name: this.chapter_name,
          isactive: true,
        };
        axios
          .post("/QuizQuestionBank/saveChapter", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", "Chapter added successfully...");
               this.chapters_list=res.data.chapters_list
            } else {
              this.showSnackbar("#b71c1c", "Chapter already present!!!");
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          })
          .finally(() => {
            this.dialog=false
           
          });
        this.close();
        },
        addChapter(){
                this.dialog=true
        },
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
        <th>Sr. No</th>
      <th>Academic Year</th>
      <th>Lecture No</th>
      <th>Chapter</th>
      <th>Remark</th>
      <th>Is Approved?</th>
      <th>Approval Date</th>
      <th>Approved By</th>
     
    </tr>`;

  this.plan_list.forEach((s, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${s.academicyear}</td>
        <td>${s.lecture_no}</td>
        <td>${s.unit}</td>
        <td>${s.remark}</td>
        <td>${s.isapproved}</td>
        <td>${s.approval_date}</td>
        <td>${s.approvedby}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
         async updateCoursePlanWeek(cp_id,week) {
              const formData = {
                  cp_id: cp_id,
                  edit_course_plan_week:week
              };
              axios
                 try {
          const res = await axios.post("/LessonPlanning/updateCoursePlanWeek", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Updated Successfully.."); // show snackbar
                 this.getLessonPlan();
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                // this.getLessonPlan();
                // this.lesson_no = res.data.lesson_plan;
      }
          },
         async updateChapter(cp_id,chapter) {
              const formData = {
                  cp_id: cp_id,
                  edit_chapter:chapter
              };
              axios
                 try {
          const res = await axios.post("/LessonPlanning/updateChapter", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Updated Successfully.."); // show snackbar
                 this.getLessonPlan();
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                // this.getLessonPlan();
                // this.lesson_no = res.data.lesson_plan;
      }
          },
        showDetails(item){
                this.showlessonplan.id=item.cp_id
                this.showlessonplan.lesson_no=item.lecture_no
                this.showlessonplan.unit= item.unit ? item.unit : item.chapter
                this.showlessonplan.topic=item.topic
                this.showlessonplan.outcome=item.learning_outcomes
                this.showlessonplan.tools=item.instructional_tool_refernences
                this.showlessonplan.pedagogy=item.pedagogy
                this.showlessonplan.assignment=item.activity_assignment_research
                this.showlessonplan.assessment=item.assessment
                this.showlessonplan.exammination=item.exam_name
                this.showlessonplan.remark=item.remark
                this.showlessonplan.courseplanweek=item.courseplanweek
                this.dialog_add_comment=true
            
        },
         async addRemark() {
            if (!confirm("Are You Sure You Want To Add Remark ...?")) return;
              const formData = {
                   cp_id: this.showlessonplan.id,
                   remark: this.showlessonplan.remark,
                   ay: this.ay
              };
              this.loader=true
              axios
                 try {
          const res = await axios.post("/LessonPlanning/addRemarkToLessonPlan", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Remark Added Successfully.."); // show snackbar
                //  this.getLessonPlan();
                this.plan_list = res.data.course_plans;
                this.islessonplanapproved = res.data.islessonplanapproved;
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                 this.loader=false
                 this.dialog_add_comment=false
      }
          },
         async approveLessonPlans(flag) {
            // alert("flag"+flag)
            if (!confirm("Are You Sure You Want To Approve lesson Plans...?")) return;
              const formData = {
                   id: this.role,
                   course: this.course,
                   islessonplanapproved:flag,
                   ay: this.ay,
                   selectedplans: [],
              };
               var index = 0;
                this.selectedTasks.forEach(function (item) {
                    formData.selectedplans[index] = item.cp_id;
                    index++;
                });
              this.loader=true
              axios
                 try {
          const res = await axios.post("/LessonPlanning/approveLessonPlans", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Lesson Plans Approved/Unapproved Successfully.."); // show snackbar
                //  this.getLessonPlan();
                this.plan_list = res.data.course_plans;
                this.islessonplanapproved = res.data.islessonplanapproved;
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                // this.getLessonPlan();
                // this.lesson_no = res.data.lesson_plan;
                 this.loader=false
      }
          },
         async rearrangelessonplans() {
            if (!confirm("Are You Sure You Want To Rearrange lesson Numbers...?")) return;
              const formData = {
                   id: this.role,
                   course: this.course,
                   ay: this.ay
              };
              this.loader=true
              axios
                 try {
          const res = await axios.post("/LessonPlanning/reaarangeCoursePlans", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Lesson Plans Updated Successfully.."); // show snackbar
                //  this.getLessonPlan();
                this.plan_list = res.data.course_plans;
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                // this.getLessonPlan();
                // this.lesson_no = res.data.lesson_plan;
                 this.loader=false
      }
          },
         async updateLessonNo(cp_id,lesson_no) {
              const formData = {
                  cp_id: cp_id,
                  lesson_no,lesson_no
              };
              axios
                 try {
          const res = await axios.post("/LessonPlanning/save_edit_lesson_number", formData);
          if (res.data.flag == "YES") {
                this.showSnackbar("green", "Lesson number Updated Successfully.."); // show snackbar
                 this.getLessonPlan();
                this.lesson_no = res.data.lesson_plan;
          }
           else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
          else{
            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
                // this.getLessonPlan();
                // this.lesson_no = res.data.lesson_plan;
      }
          },
          addnewLessonPlanData(edit_course_plan_id, type) {
              // alert(edit_course_plan_id);
              // alert(type);
              var added_value;
              if (type == "unit") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.unit);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { unit: this.addnewlessonplan.unit };
                  added_value = this.add_new_list;
              }
              if (type == "topic") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.topic);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { topic: this.addnewlessonplan.topic };
                  added_value = this.add_new_list;
              }
              if (type == "tool") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.tools);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { tool: this.addnewlessonplan.tools };
                  added_value = this.add_new_list;
              }
              if (type == "outcome") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.outcome);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { outcome: this.addnewlessonplan.outcome };
                  added_value = this.add_new_list;
              }
              if (type == "pedagogy") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.pedagogy);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { pedagogy: this.addnewlessonplan.pedagogy };
                  added_value = this.add_new_list;
              }
              if (type == "assignment") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.assignment);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { assignment: this.addnewlessonplan.assignment };
                  added_value = this.add_new_list;
              }
              if (type == "assessment") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.assessment);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = { assessment: this.addnewlessonplan.assessment };
                  added_value = this.add_new_list;
              }
              if (type == "examination") {
                  const isAllWhiteSpace = /^\s+$/.test(this.addnewlessonplan.exammination);
                  if (isAllWhiteSpace) {
                      this.showSnackbar("error", "Please add data !!!");
                      return;
                  }
                  this.add_new_list[0] = {
                      exammination: this.addnewlessonplan.exammination,
                  };
                  added_value = this.add_new_list;
              }
              // alert(added_value)
              const formData = {
                  edit_course_plan_id: edit_course_plan_id,
                  added_value: added_value,
                  type: type,
              };
              axios
                  .post("/LessonPlanning/save_add_new_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Added Successfully!!!"); // show snackbar on success
                          this.editItem(edit_course_plan_id);
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.dialog_add_new = false;
                      (this.addnewlessonplan.type = null),
                          (this.addnewlessonplan.unit = null),
                          (this.addnewlessonplan.topic = null),
                          (this.addnewlessonplan.outcome = null),
                          (this.addnewlessonplan.tools = null),
                          (this.addnewlessonplan.pedagogy = null),
                          (this.addnewlessonplan.assignment = null),
                          (this.addnewlessonplan.assessment = null),
                          (this.addnewlessonplan.exammination = null);
                          this.add_new = false
                          this.getLessonPlan();
                  });
          },
          deletelistvalue(index, type, edit_course_plan_id) {
              this.delete_index = index;
              this.delete_type = type;
              this.edit_course_plan_id = edit_course_plan_id;
              this.dialog_delete = true;
          },
          deletelistvalue_yes(index, type, edit_course_plan_id) {
              var list;
              if (type == "unit") {
                  this.unit_list.splice(index, 1);
                  //console.log(this.unit_list)
                  list = this.unit_list;
              }
              if (type == "topic") {
                  this.topic_list.splice(index, 1);
                  list = this.topic_list;
              }
              if (type == "tool") {
                  this.tool_list.splice(index, 1);
                  list = this.tool_list;
              }
              if (type == "outcome") {
                  this.outcome_list.splice(index, 1);
                  list = this.outcome_list;
              }
              if (type == "pedagogy") {
                  this.pedagogy_list.splice(index, 1);
                  list = this.pedagogy_list;
              }
              if (type == "assignment") {
                  this.assignment_list.splice(index, 1);
                  list = this.assignment_list;
              }
              if (type == "assessment") {
                  this.assessment_list.splice(index, 1);
                  list = this.assessment_list;
              }
              if (type == "examination") {
                  this.examination_list.splice(index, 1);
                  list = this.examination_list;
              }
              const formData = {
                  edit_course_plan_id: edit_course_plan_id,
                  edited_unit: list,
                  type: type,
              };
              axios
                  .post("/LessonPlanning/save_edit_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Deleted Successfully!!!"); // show snackbar on success
                          this.editItem(edit_course_plan_id);
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.dialog_delete = false;
                  });
          },
          save_edit_item(edit_course_plan_id, value, index, type) {
              var edited_value;
              const isAllWhiteSpace = /^\s+$/.test(value);
              if (isAllWhiteSpace) {
                  this.showSnackbar("error", "Please add data !!!");
                  return;
              }
              if (type == "unit") {
                  this.unit_list[index] = { unit: value };
                  edited_value = this.unit_list;
              }
              if (type == "topic") {
                  this.topic_list[index] = { topic: value };
                  edited_value = this.topic_list;
              }
              if (type == "tool") {
                  this.tool_list[index] = { tool: value };
                  edited_value = this.tool_list;
              }
              if (type == "outcome") {
                  this.outcome_list[index] = { outcome: value };
                  edited_value = this.outcome_list;
              }
              if (type == "pedagogy") {
                  this.pedagogy_list[index] = { pedagogy: value };
                  edited_value = this.pedagogy_list;
              }
              if (type == "assignment") {
                  this.assignment_list[index] = { assignment: value };
                  edited_value = this.assignment_list;
              }
              if (type == "assessment") {
                  this.assessment_list[index] = { assessment: value };
                  edited_value = this.assessment_list;
              }
              if (type == "examination") {
                  this.examination_list[index] = { examination: value };
                  edited_value = this.examination_list;
              }
              const formData = {
                  edit_course_plan_id: edit_course_plan_id,
                  edited_unit: edited_value,
                  type: type,
              };
              axios
                  .post("/LessonPlanning/save_edit_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Updated Successfully!!!"); // show snackbar on success
                          this.editItem(edit_course_plan_id);
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.edit_unit = null;
                      this.edit_topic = null;
                      this.edit_outcome = null;
                      this.edit_tool = null;
                      this.edit_pedagogy = null;
                      this.edit_assignment = null;
                      this.assessment_edit = null;
                      this.exammination_edit = null;
                  });
          },
          editunit(value, index, type) {
              //alert(index)
              if (type == "unit") {
                  this.edit_unit = value;
                  this.unit_index = index;
              }
              if (type == "topic") {
                  this.edit_topic = value;
                  this.topic_index = index;
              }
              if (type == "tool") {
                  this.edit_tool = value;
                  this.tool_index = index;
              }
              if (type == "outcome") {
                  this.edit_outcome = value;
                  this.outcome_index = index;
              }
              if (type == "pedagogy") {
                  this.edit_pedagogy = value;
                  this.pedagogy_index = index;
              }
              if (type == "assignment") {
                  this.edit_assignment = value;
                  this.assignment_index = index;
              }
              if (type == "assessment") {
                  this.assessment_edit = value;
                  this.aassessment_index = index;
              }
              if (type == "examination") {
                  this.exammination_edit = value;
                  this.exammination_index = index;
              }
          },
          addnew() {
              (this.add_new = true), (this.edit_new = false);
          },
          deletedItem(cp_id) {
              this.edit_course_plan_id = cp_id;
              this.dialog_delete1 = true;
          },
          deleteplan(cp_id) {
              const formData = {
                  cp_id: cp_id,
              };
              axios
                  .post("/LessonPlanning/save_delete_plan", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Deleted Successfully!!!"); // show snackbar on succes
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.dialog_delete1 = false;
                  });
          },
          editItem(cp_id) {
              // alert("editItem")
              (this.add_new = false), (this.edit_new = true);
              const formData = {
                  cp_id: cp_id,
              };
              axios
                  .post("/LessonPlanning/editLessonPlanWWS", formData)
                  .then((res) => {
                      this.unit_list = res.data.unit_list;
                      this.topic_list = res.data.topic_list;
                      this.outcome_list = res.data.outcome_list;
                      this.tool_list = res.data.tool_list;
                      this.pedagogy_list = res.data.pedagogy_list;
                      this.assignment_list = res.data.assignment_list;
                      this.assessment_list = res.data.assessment_list;
                      this.examination_list = res.data.examination_list;
                      this.edit_course_plan_id = res.data.cp_id;
                      this.lesson_no_edit = res.data.lesson_no;
                      this.edit_course_plan_week = res.data.courseplanweek_id;
                      this.edit_chapter = res.data.chapter_id;
                      this.filepath = res.data.filepath;
                      this.filename = res.data.filename;
                    //   this.edit_plan_details_list = res.data.plan_details_list;
                    this.edit_plan_details_list = res.data.plan_details_list.map(p => ({
                        ...p,
                        chapter_id: p.chapter_id ? Number(p.chapter_id) : null,
                        courseplanweek_id: p.courseplanweek_id ? Number(p.courseplanweek_id) : null
                    }));
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },
          addPlanFile(edit_course_plan_id, edit_file) {
              if (edit_file == null || edit_file == "") {
                  this.showSnackbar("#b71c1c", "Please Add File...");
                  return;
              }
              let formData = new FormData();
              formData.append("file", edit_file);
              formData.append("edit_course_plan_id", edit_course_plan_id);
              axios
                  .post("/LessonPlanning/addPlanFile", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning File Added Successfully!!!"); // show snackbar on success
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },
          deletePlanFile(edit_course_plan_id) {
           this.edit_course_plan_id=edit_course_plan_id;
           const data = {
                  edit_course_plan_id: edit_course_plan_id,
              };
              axios
                  .post("/LessonPlanning/deletePlanFile", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning File Deleted Successfully!!!"); // show snackbar on success
                          this.getLessonPlan();
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.editItem(this.edit_course_plan_id)
                  });
          },
          getLessonPlan() {
              this.plan = true;
              this.edit_new = false;
              const formData = {
                  ay: this.ay,
                  crs: this.course,
              };
              axios
                  .post("/LessonPlanning/getLessonPlan_New", formData)
                  .then((res) => {
                      this.plan_list = res.data.plan_list;
                      this.lesson_no = res.data.lesson_plan;
                      this.islessonplanapproved=res.data.islessonplanapproved
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                  });
          },
          saveLessonPlan() {
              let formData = new FormData();
              formData.append("ay", this.ay);
              formData.append("file", this.file);
              formData.append("crs", this.course);
              formData.append("lesson_no", this.lesson_no);
              formData.append("unit", this.unit);
              formData.append("chapter", this.chapter);
              formData.append("topic", this.topic);
              formData.append("outcome", this.outcome);
              formData.append("tools", this.tools);
              formData.append("pedagogy", this.pedagogy);
              formData.append("assignment", this.assignment);
              formData.append("exammination", this.exammination);
              formData.append("assessment", this.assessment);
              formData.append("course_plan_week", this.course_plan_week);
              this.loader=true
              axios
                  .post("/LessonPlanning/saveLessonPlan_new", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Lesson Planning Added Successfully!!!"); // show snackbar on success
                         this.lesson_no = res.data.lesson_plan;
                        //   this.getLessonPlan();
                        this.loader=false
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      (this.file = null), (this.unit = null), (this.topic = null), (this.outcome = null), (this.tools = null), (this.pedagogy = null), (this.assignment = null), (this.assessment = null), (this.exammination = null);
                       this.course_plan_week=null;
                      this.add_new = false;
                      this.getLessonPlan();
                      this.lesson_no = res.data.lesson_plan;
                      this.loader=false
                  });
          },
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          onload() {
              axios
                  .post("/commonAPI/get_ay_std_div")
                  .then((res) => {
                      this.ay_std_div_list = res.data.data;
                      this.sel_ay_data = res.data.curr_ay;
                      this.aws_path = res.data.aws_path;
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {});
          },
      },
      mounted() {
          //alert("role" + this.role);
          // this.onload();
          this.add_new = false
      },
    created() {
        this.aws_path = localStorage.getItem("awspath");
    }
};
</script>
<style scoped>
  .v-col {
      padding: 0rem !important;
      margin: 0rem !important;
  }

  .btn {
      margin-left: 2%;
  }
  .btn1 {
      margin-left: 0.5rem;
  }
</style>
